export const UPDATE_PRODUCT_LISTING_PAGE_DATA = 'UPDATE_PRODUCT_LISTING_PAGE_DATA'
